import axios from 'axios'

const properties = require('../properties.json');

const baseUrl = properties['Network']['BaseUrl'];

export class ClientTransactionsService {
  getAllClientTransactions(id){
    return axios.get(
      `${baseUrl}/Sms/ClientTransactions/${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        },
      }
    ).then(response => response.data).catch(error => error.response)
  }
}

